// extracted by mini-css-extract-plugin
export var equalColumn = "_ed-0";